import React, { useEffect, useState } from 'react';
import axios from 'axios';
import queryString from 'query-string';
import { RoomBooking } from './RoomBooking';
import { HotDesk } from './HotDesk';
// import location from '../../static/icons/location.png';
// import colleague from '../../static/icons/colleague.png';
// import booking from '../../static/icons/booking.png';
import circle from '../../static/icons/qrCircle.png';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const MyBooking = (props) => {
  const parsedQueryString = queryString.parse(window.location.search);
  const siteId = parseInt(parsedQueryString.siteId, 10);
  const deskId = parseInt(parsedQueryString.deskId, 10);
  const roomId = parseInt(parsedQueryString.roomId, 10);
  const isRoom = parsedQueryString.isRoom ? JSON.parse(parsedQueryString.isRoom?.toLowerCase()) : '';
  const isOffice = parsedQueryString.isOffice ? JSON.parse(parsedQueryString.isOffice?.toLowerCase()) : '';
  const [newBooking, setNewBooking] = useState(null);
  const deskName = parsedQueryString.deskName;
  const siteName = parsedQueryString.siteName;
  const [sites, setSites] = useState();
  const [sName, setSName] = useState(''); //site name based on id from query string
  const [isD, setIsD] = useState(false); //desk boiking
  const [isR, setIsR] = useState(false); //room booking
  const [isO, setIsO] = useState(false); //office booking
  const [employee, setEmployee] = useState();
  const [page, setPage] = useState(null);
  const [bookingType, setBookingType] = useState(isRoom ? 'Booked Meeting Room' : isOffice ? 'Booked Private Office' : !isNaN(deskId) ? 'Booked Meeting Desk' : '');

  const checkToken = async (token, employeeId) => {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/verifyToken?token=${token}&employeeId=${employeeId}`);
    return data.success;
  };

  const getSites = async () => {
    const token = localStorage.getItem('token');
    const employee = JSON.parse(localStorage.getItem('employee'));
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/sites?token=${token}&accountId=${employee.accountId}`);
    return data.success;
  };

  useEffect(() => {
    if (sites?.length) {
      const filterSite = sites.filter((s) => s.id === siteId);
      setSName(filterSite[0]?.name);
    }
  }, [sites]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sites) {
      const Sites = getSites();
      Sites.then((s) => {
        setSites(s);
      });
    }
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.hideLoader();
  }, [props]);

  useEffect(() => {
    var tokenExpiration = localStorage.getItem('tokenExpiration');
    var token = localStorage.getItem('token');
    var employee = JSON.parse(localStorage.getItem('employee'));
    if (token && employee) {
      var check = checkToken(token, employee['id']);
      if (!check) {
        localStorage.clear();
        setPage(null);
      }
    }
    if (tokenExpiration === new Date() || tokenExpiration === null) {
      localStorage.clear();
      setPage(null);
    } else {
      setPage(0);
      setEmployee(JSON.parse(localStorage.getItem('employee')));
      setSites(JSON.parse(localStorage.getItem('sites')));
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    setPage(null);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let email = e.target.elements.email?.value;
    let password = e.target.elements.password?.value;
    try {
      const response = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/login?siteId=` + siteId, {
        email: email,
        password: password,
      });
      if (response.data.success.token) {
        localStorage.setItem('token', response.data.success.token);
        localStorage.setItem('employee', JSON.stringify(response.data.success.employee));
        var date = new Date();
        date.setDate(date.getDate() + 1);
        localStorage.setItem('tokenExpiration', date);
        const sites = await getSites();
        setTimeout(() => {
          localStorage.setItem('sites', JSON.stringify(sites));
          setSites(sites);
          setEmployee(response.data.success.employee);
          setPage(0);
        }, 3000);
      }
    } catch (error) {
      alert(error);
    }
  };

  // function meetingRoom() {
  //   setPage(1);
  // }

  // function privateOffice() {
  //   setPage(1);
  // }

  // function hotDesk() {
  //   setPage(2);
  // }

  return (
    <div className="container max-w-sm mx-auto">
      <div className="full-window columns-1 align-top px-8 pt-6 pd-8 mb-4">
        {page === null ? (
          <div>
            <div className="grid grid-rows-1 mt-20">
              <h1 className="text-center text-black">
                Log in to your account{' '}
                <span role="img" aria-label="lock">
                  🔐
                </span>
              </h1>
              <form onSubmit={handleFormSubmit}>
                <div className="grid grid-rows-1 flex justify-around mt-10">
                  <label className="text-black" htmlFor="email">
                    Email
                  </label>
                  <input className="border-solid rounded-md border-2 border-sky-500 px-2 py-1 mt-2 text-black" type="email" id="email" placeholder="Your Email" />
                </div>
                <div className="grid grid-rows-1 flex justify-around mt-5">
                  <label className="text-black" htmlFor="password">
                    Password
                  </label>
                  <input
                    className="border-solid rounded-md border-2 border-sky-500 px-2 py-1 mt-2 text-black"
                    type="password"
                    id="password"
                    placeholder="Your Password"
                  />
                </div>
                <div className="flex justify-center mt-10">
                  <button type="submit" className="rounded-full w-full h-10 bg-blue-600 text-white text-center mx-10">
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : null}
        {page === 0 ? (
          <div id={0}>
            <div className="grid-rows-1 mt-5">
              <p className="text-center text-black text-xl">Hi, {employee?.name}</p>
            </div>
            <div className="grid-rows-1 mt-10">
              <p className="text-center text-black text-xl">Welcome to {sName} Room Booking</p>
            </div>
            <div className="grid-rows-1 p-2">
              <img className="mx-auto h-24 object-center" src={`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getLogo/${siteId}?small=true`} alt="Logo" />
            </div>
            {isNaN(deskId) && isNaN(roomId) ? (
              <div>
                <div className="grid-rows-1 mt-10 h-10">
                  <p className="text-center text-black text-xl">Would you like to book a</p>
                </div>
                <div className="w-90 h-10 grid-rows-1 flex justify-center mt-5">
                  <button
                    onClick={() => {
                      setBookingType('Booked Meeting Desk');
                      setIsD(true);
                      setPage(2);
                    }}
                    className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                  >
                    Book Hot Desk
                  </button>
                </div>
                <div className="w-90 h-10 grid-rows-1 flex justify-center mt-5">
                  <button
                    onClick={() => {
                      setBookingType('Booked Private Office');
                      setIsO(true);
                      setPage(1);
                    }}
                    className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                  >
                    Private Office
                  </button>
                </div>
                <div className="w-90 h-10 grid-rows-1 flex justify-center mt-5">
                  <button
                    onClick={() => {
                      setBookingType('Booked Meeting Room');
                      setIsR(true);
                      setPage(1);
                    }}
                    className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                  >
                    Meeting Room
                  </button>
                </div>
                <div className="w-90 h-10 grid-rows-1 flex justify-center mt-5">
                  <button onClick={logout} className="w-full bg-white border-2 border-blue-500 text-blue-600 font-bold py-2 px-4 rounded-full">
                    Log Out
                  </button>
                </div>
              </div>
            ) : null}
            {!isNaN(deskId) ? (
              <div>
                <div
                  onClick={() => {
                    setNewBooking(true);
                    setPage(2);
                  }}
                  className="w-full flex justify-center mt-5 grid grid-cols-1"
                >
                  <div className="flex flex-row justify-around">
                    <img src={circle} style={{ width: '60px', height: '60px' }} alt="circle" />
                    <p className="w-48 text-left text-black text-xl">Do you want to book this desk?</p>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setNewBooking(false);
                    setPage(2);
                  }}
                  className="w-full flex justify-center mt-5 grid grid-cols-1"
                >
                  <div className="flex flex-row justify-around">
                    <img src={circle} style={{ width: '60px', height: '60px' }} alt="circle" />
                    <p className="w-48 text-left text-black text-xl">Signing in for your reservation?</p>
                  </div>
                </div>
              </div>
            ) : null}
            {!isNaN(roomId) ? (
              <div>
                <div
                  onClick={() => {
                    setNewBooking(true);
                    setPage(1);
                  }}
                  className="w-full flex justify-center mt-5 grid grid-cols-1"
                >
                  <div className="flex flex-row justify-around">
                    <img src={circle} style={{ width: '60px', height: '60px' }} alt="circle" />
                    <p className="w-48 text-left text-black text-xl">Do you want to book this room?</p>
                  </div>
                </div>
                <div
                  onClick={() => {
                    setNewBooking(false);
                    setPage(1);
                  }}
                  className="w-full flex justify-center mt-5 grid grid-cols-1"
                >
                  <div className="flex flex-row justify-around">
                    <img src={circle} style={{ width: '60px', height: '60px' }} alt="circle" />
                    <p className="w-48 text-left text-black text-xl">Signing in for your reservation?</p>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        {page === 1 ? (
          <div id={1}>
            <RoomBooking
              sites={sites}
              roomId={roomId}
              roomName={deskName}
              siteId={siteId}
              siteName={siteName}
              newBooking={newBooking}
              bookingType={bookingType}
              isRoom={isR}
              isOffice={isO}
            />
          </div>
        ) : null}
        {page === 2 ? (
          <div id={2}>
            <HotDesk sites={sites} deskId={deskId} deskName={deskName} siteId={siteId} newBooking={newBooking} siteName={siteName} isDesk={isD} />
          </div>
        ) : null}
        {page === 0 ? (
          <div className={`mt-10`}>
            <p className="text-center text-black text-xs mt-10">Powered by MyLobby.co</p>
          </div>
        ) : null}
      </div>
      {/* {page >= 1 ? (
        <div>
          <div className="w-full max-w-sm fixed bottom-0 bg-gray-800 flex justify-between text-sm text-blue-900 uppercase font-mono py-2">
            <div className="grid grid-cols-1">
              <img className="mx-auto w-6 h-6" src={location} alt="desk" />
              <div className="w-full block py-2 px-3 capitalize text-xs text-center text-white">Book A Desk</div>
            </div>
            <div className="grid grid-cols-1">
              <img className="mx-auto w-6 h-6" src={colleague} alt="colleague" />
              <div className="w-full block py-2 px-3 text-xs capitalize tracking-tighter text-center text-white">Find A Colleague</div>
            </div>
            <div className="grid grid-cols-1">
              <img className="mx-auto w-6 h-6" src={booking} alt="booking" />
              <div className="w-full block py-2 px-3 text-xs capitalize text-center text-white">Booking</div>
            </div>
          </div>
        </div>
      ) : null} */}
    </div>
  );
};
